import React from "react";
import classNames from "classnames";

const ProgrammeInfo = ({ className, ...props }) => (
  <div {...props} className={classNames("programme-info", className)} />
);

export default ProgrammeInfo;
